export default __webpack_public_path__ + "static/50-best-companies-06283be8c20977cf554d01d87c769288.svg";